import React from 'react';
import PropTypes from 'prop-types';
import { useRecordContext } from 'react-admin';
import { Typography } from '@mui/material';

import usePayoutClaims from '../../hooks/usePayoutClaims';
import { useConstantContext } from './ConstantsContext';

// PI never changes these again, so there is nothing to refresh.
export const finalPayoutClaimStatuses = ['SENT', 'REJECTED', 'CANCELLED'];

export const usePayoutClaim = (accountId) => {
  const record = useRecordContext();
  const { constants } = useConstantContext();
  const isPayout = record?.type === constants.transactionTypes?.WITHDRAWAL
    && !!record?.paymentDetails?.payedOutAt;
  const { data: claims } = usePayoutClaims(accountId, isPayout);
  if (!isPayout || !Array.isArray(claims)) return undefined;
  // Claims arrive newest first, so the first match is the latest claim for this transaction.
  return claims.find((claim) => claim.transactionId === record._id);
};

const formatDate = (date) => (date ? new Date(date).toLocaleString('sv-SE') : '-');

// Shows the claim status as reported by payment integration (CREATED and FAILED are Moank's own).
const PayoutClaimStatus = ({ accountId }) => {
  const claim = usePayoutClaim(accountId);
  if (!claim) return null;

  return (
    <>
      <Typography variant="body2">{claim.status}</Typography>
      <Typography variant="caption" display="block" color="text.secondary">
        {`Last checked: ${formatDate(claim.lastPolledAt ?? claim.updatedAt)}`}
      </Typography>
    </>
  );
};

PayoutClaimStatus.propTypes = {
  accountId: PropTypes.string,
  // eslint-disable-next-line react/no-unused-prop-types
  label: PropTypes.string,
};

PayoutClaimStatus.defaultProps = {
  accountId: undefined,
  label: 'Payout claim',
};

export default PayoutClaimStatus;
